document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.toplayout');
  if (!section) return;

  const stage = section.querySelector('.insp-stage');
  const isNarrow = () => window.matchMedia('(max-width: 991px)').matches;

  /* The frame's y values are page coordinates; CSS offsets them by where the
     stage starts (under the header). Keep that exact rather than assumed. */
  const syncOrigin = () => {
    if (!stage) return;
    const y0 = stage.getBoundingClientRect().top + window.scrollY;
    section.style.setProperty('--insp-y0', y0 + 'px');
  };
  syncOrigin();

  /* The frame's hard line breaks only make sense at its measure. Drop them
     before SplitText runs so narrow screens just wrap. */
  if (isNarrow()) {
    section.querySelectorAll('.insp-br').forEach((br) => br.remove());
  }
  const layers = Array.from(section.querySelectorAll('.background__layer'));
  const frame = section.querySelector('.shape-frame');
  const shapeStroke = document.getElementById('shape-stroke');
  const grains = Array.from(section.querySelectorAll('.grain-layers svg'));

  /* Each bottle is two elements moved as one: a white ground and the shape that
     blends over it. See the note in inspiration.css - without the ground the
     exclusion has nothing to invert and the shape stays white on a white page. */
  const bottle = (name) => [
    section.querySelector('.grain-ground--' + name),
    section.querySelector('.grain-layer--' + name),
  ];
  const bottleA = bottle('top');
  const bottleB = bottle('bottom');
  const bottleC = bottle('second');
  const allBottles = bottleA.concat(bottleB, bottleC);

  const hoverWrap = section.querySelector('.insp-hovers');
  const hoverImg = hoverWrap && hoverWrap.querySelector('.insp-hover-img');
  const hideHover = () => {
    if (hoverWrap) hoverWrap.classList.remove('is-on');
    section.querySelectorAll('.insp-frame.is-mark-hover').forEach((node) => {
      node.classList.remove('is-mark-hover');
    });
    section.querySelectorAll('.is-hovered').forEach((node) => {
      node.classList.remove('is-hovered');
    });
  };
  if (hoverWrap && hoverImg) {
    let scrolling = false;
    let scrollHideTimer = 0;
    const onScrollStart = () => {
      scrolling = true;
      if (hoverWrap.classList.contains('is-on')) hideHover();
      window.clearTimeout(scrollHideTimer);
      scrollHideTimer = window.setTimeout(() => {
        scrolling = false;
      }, 80);
    };
    window.addEventListener('wheel', onScrollStart, { passive: true });
    window.addEventListener('touchmove', onScrollStart, { passive: true });

    const markTarget = (node) =>
      node && node.closest && (node.closest('.insp-mark') || node.closest('[data-hover-img]'));
    const showHover = (mark, src) => {
      if (scrolling) return;
      section.querySelectorAll('.insp-frame.is-mark-hover').forEach((node) => {
        node.classList.remove('is-mark-hover');
      });
      section.querySelectorAll('.is-hovered').forEach((node) => {
        node.classList.remove('is-hovered');
      });
      const frameEl = mark.closest('.insp-frame');
      if (frameEl && !mark.closest('.insp-block--7')) {
        frameEl.classList.add('is-mark-hover');
        mark.classList.add('is-hovered');
      }
      hoverWrap.setAttribute('data-edge', mark.getAttribute('data-hover-edge') || 'top-left');
      const widthVw = mark.getAttribute('data-hover-width') || '50';
      hoverWrap.style.setProperty('--insp-hover-w', widthVw + 'vw');
      const reveal = () => {
        if (scrolling) return;
        hoverWrap.classList.add('is-on');
      };
      hoverImg.onload = reveal;
      hoverImg.onerror = () => hoverWrap.classList.remove('is-on');
      if (hoverImg.getAttribute('src') === src && hoverImg.complete && hoverImg.naturalWidth) {
        reveal();
        return;
      }
      hoverImg.src = src;
    };
    section.addEventListener('pointerover', (e) => {
      const mark = markTarget(e.target);
      if (!mark) return;
      const src = mark.getAttribute('data-hover-img');
      if (!src) return;
      showHover(mark, src);
    });
    section.addEventListener('pointerout', (e) => {
      const mark = markTarget(e.target);
      if (!mark) return;
      if (e.relatedTarget && mark.contains(e.relatedTarget)) return;
      hideHover();
    });
  }

  const bodies = Array.from(section.querySelectorAll('[data-animate="body"]'));

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    bodies.forEach((p) => gsap.set(p, { '--mark-a': 1 }));
    return;
  }

  const STATE_COUNT = 8;
  const PHOTO_TOP = [211, 63.79, -100, -349, -562, -775, -775, -775];
  const OUTLINE_W = [3435.93, 1385.32, 1456.55, 1456.55, 1456.55, 1385.32, 1151.44, 1151.44];
  const layerCentre = section.querySelector('.background__layer--1');

  const outlineScales = () => {
    const path = frame.querySelector('path');
    if (!path) return OUTLINE_W.map(() => 1);
    const prev = frame.style.transform;
    frame.style.transform = 'none';
    const base = path.getBoundingClientRect().width || 1;
    frame.style.transform = prev;
    return OUTLINE_W.map((w) => w / base);
  };

  layers.forEach((layer) => {
    if (layer === layerCentre) return;
    const speed = Number(layer.dataset.speed) || 0.3;
    const exitY = () => -(layer.offsetTop + layer.offsetHeight
                          + 0.35 * window.innerHeight);
    gsap.fromTo(
      layer,
      { y: () => -speed * 0.4 * window.innerHeight },
      {
        y: exitY,
        ease: 'none',
        scrollTrigger: {
          trigger: section, start: 'top top', end: 'bottom bottom',
          scrub: true, invalidateOnRefresh: true,
        },
      }
    );
  });

  gsap.set(grains, { autoAlpha: 0 });
  gsap.set(allBottles, {
    x: 0, y: 0, rotation: 0, transformOrigin: '50% 50%', force3D: true,
  });
  gsap.set(bottleC, { rotation: 90, xPercent: 30, yPercent: -20, autoAlpha: 0 });
  gsap.set(frame, { force3D: false, transformOrigin: '50% 50%',
    scale: outlineScales()[0] });

  bodies.forEach((p) => {
    const isLead = p.closest('.insp-block--1');
    const delayMs = Number(p.dataset.delay || 0);
    const delaySec = delayMs > 20 ? delayMs / 1000 : delayMs;
    gsap.set(p, { '--mark-a': isLead ? 1 : 0 });
    if (typeof window.animateBodyText !== 'function') return;
    window.animateBodyText(p, {
      useScrollTrigger: true,
      autoPlay: true,
      delay: delaySec,
      onReady: (elem) => {
        const lineTl = elem._bodyLineTimeline;
        if (!lineTl) return;
        if (isLead) {
          lineTl.set(elem, { '--mark-a': 1 }, 0);
          return;
        }
        lineTl.fromTo(
          elem,
          { '--mark-a': 0 },
          { '--mark-a': 1, duration: elem.classList.contains('tail') ? 0.5 : 0.4, ease: 'none' },
          delaySec + (elem.classList.contains('tail') ? 0.2 : 0)
        );
      },
    });
  });

  /* Image: the frame clips, the picture is taller and lags the page inside
     it, so it reads as further away. Snapped to device pixels so the 1-bit
     dither in the picture does not shimmer while it drifts. */
  const figure = section.querySelector('[data-insp-parallax]');
  const figureImg = figure && figure.querySelector('img');
  if (figure && figureImg) {
    const travel = () => Math.max(0, figureImg.offsetHeight - figure.offsetHeight) / 2;
    const snap = (v) => {
      const dpr = window.devicePixelRatio || 1;
      return Math.round(parseFloat(v) * dpr) / dpr + 'px';
    };
    gsap.fromTo(figureImg, { yPercent: -50, y: () => -travel() }, {
      yPercent: -50,
      y: () => travel(),
      ease: 'none',
      modifiers: { y: snap },
      scrollTrigger: {
        trigger: figure, start: 'top bottom', end: 'bottom top',
        scrub: true, invalidateOnRefresh: true,
      },
    });
    if (!figureImg.complete) figureImg.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
  }

  /* Paragraph hand-offs, the way the old local build moved them: blocks move
     whole, each at its own speed, and the ones above peel away top-first
     while the next frame is still coming in. Here that is an extra lift on
     the way out and a small lag on the way in, scrubbed against where the
     incoming frame is on screen, so every block rests on its Figma spot
     between hand-offs. Values are fractions of the viewport height. */
  const mm = gsap.matchMedia();
  mm.add('(min-width: 992px)', () => {
    const q = (sel) => section.querySelector(sel);
    const title = q('.insp-title');
    const b1 = q('.insp-block--1');
    const b2 = q('.insp-block--2');
    const b3 = q('.insp-block--3');
    const b4 = q('.insp-block--4');
    const b6 = q('.insp-block--6');
    const b7 = q('.insp-block--7');
    const vh = () => window.innerHeight;
    /* One Figma px in CSS px, read off the copy itself (55 at 1728). */
    const unit = () => {
      const lead = b1 && b1.querySelector('p');
      return lead ? parseFloat(getComputedStyle(lead).fontSize) / 55 : 1;
    };
    const maxScroll = () => ScrollTrigger.maxScroll(window);
    /* Scroll position at which an element's resting top sits at a given
       fraction of the viewport. Read from layout (offsetTop ignores the
       transforms these tweens add), so it follows the CSS - including the
       drop that keeps the image below the first screen. Clamped to the page. */
    const pageTop = (el) => stage.getBoundingClientRect().top + window.scrollY + el.offsetTop;
    const at = (el, frac) => () =>
      Math.min(maxScroll(), Math.max(0, pageTop(el) - frac * vh()));

    const handoff = (next, leaving, arriving) => {
      const tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          start: at(next, 1),
          end: at(next, 0.3),
          scrub: 0.6,
          invalidateOnRefresh: true,
        },
      });
      /* Out: earlier and further for the block higher up, so gaps open and
         nothing collides. power1.in = it gathers speed as it goes. */
      /* Departures ride yPercent and arrivals ride y, so a block that both
         arrives and later leaves (4) never has two scrubs on one channel. */
      leaving.forEach(([el, lift, at0]) => {
        if (el) tl.to(el, {
          yPercent: () => -100 * lift * vh() / Math.max(1, el.offsetHeight),
          duration: 1, ease: 'power1.in',
        }, at0);
      });
      /* In: starts low and settles as the frame takes its place. */
      arriving.forEach(([el, lag, at0]) => {
        if (el) tl.fromTo(el, { y: () => lag() }, { y: 0, duration: 1, ease: 'power2.out', immediateRender: true }, at0);
      });
      return tl;
    };

    /* Title, (1)(2)(3) leave as the image comes up - top first. */
    handoff(figure, [[title, 0.5, 0], [b1, 0.42, 0], [b2, 0.34, 0.18], [b3, 0.26, 0.36]], []);
    /* Arrival lags in px. The close frame has only ~95 frame-px under the
       closing line before the footer, and the stage clips there. */
    const lagVh = (f) => () => f * vh();
    const lagCapped = (f, roomFig) => () => Math.min(f * vh(), roomFig * unit());

    /* (4) comes in under the image. */
    handoff(b4, [], [[b4, lagVh(0.16), 0]]);
    /* The close frame (1022:141) arrives and (4) peels away above it. */
    handoff(b6, [[b4, 0.4, 0]], [[b6, lagCapped(0.12, 180), 0.12], [b7, lagCapped(0.12, 90), 0.3]]);

    return () => gsap.set([title, b1, b2, b3, b4, b6, b7].filter(Boolean), { clearProps: 'transform,y,yPercent' });
  });

  ScrollTrigger.addEventListener('refreshInit', syncOrigin);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => ScrollTrigger.refresh());
  }

  const tl = gsap.timeline({
    defaults: { ease: 'none', duration: 1 },
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.6,
      invalidateOnRefresh: true,
    },
  });

  for (let i = 0; i < STATE_COUNT - 1; i++) {
    tl.to(frame, { scale: () => outlineScales()[i + 1] }, i);
    tl.to(layerCentre, { y: PHOTO_TOP[i + 1] - PHOTO_TOP[0] }, i);
  }

  tl.to(shapeStroke, { opacity: 0, duration: 0.25 }, 0.75)
    .to(grains, { autoAlpha: 1, duration: 0.25 }, 0.75);

  tl.to(bottleA, { rotation: 60, xPercent: 30, yPercent: -20 }, 1)
    .to(bottleB, { rotation: 135, xPercent: -60, yPercent: 50 }, 1)
    .to(bottleA, { rotation: 90, xPercent: 30, yPercent: -20 }, 2)
    .to(bottleB, { rotation: 245, xPercent: -60, yPercent: -40 }, 2);

  const OUT_Y = () => -1.3 * window.innerHeight;

  tl.to(bottleB, { y: () => OUT_Y() }, 4);

  const BIG = 3105.396 / 1361;
  const BIG_W = () => 0.9 * window.innerWidth * (570 / 1441) * BIG;
  const BIG_SEP = () => BIG_W() * (1 - 488 / 1151.439);
  const SPLIT_END = 2;

  tl.to(bottleC, { autoAlpha: 1, duration: 0.25 }, 5)
    .to(bottleA, {
      scale: BIG, xPercent: 0, yPercent: 0,
      x: () => BIG_SEP() / 2, y: () => -23.18,
      duration: SPLIT_END,
    }, 5)
    .to(bottleC, {
      scale: BIG, xPercent: 0, yPercent: 0,
      x: () => -BIG_SEP() / 2, y: () => -23.18,
      duration: SPLIT_END,
    }, 5)
    .to(layerCentre, {
      y: () => PHOTO_TOP[STATE_COUNT - 1] - PHOTO_TOP[0] - 0.45 * window.innerHeight,
      duration: SPLIT_END,
    }, 5);
});
